import React from "react";
import "./Gray_Btn.css";
import { Button } from "react-bootstrap";

function Gray_Btn({btnText,onClick}) {
  return (
    <>
      <section className="Gray_Btn_holder">
        <Button className="Gray_Btn" onClick={onClick}>{btnText}</Button>
      </section>
    </>
  );
}

export default Gray_Btn;
